export default {
      id: "fullscreen-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#fullscreen",
      toString: function () {
        return this.url;
      }
    }